import { Station as StationType } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { CSSProperties } from 'react';

type StyleProps = CSSProperties & {
  '--col-start': CSSProperties['gridColumnStart'];
  '--col-end': CSSProperties['gridColumnEnd'];
  '--bg-color': CSSProperties['backgroundColor'];
  '--border-color': CSSProperties['borderColor'];
};

export function Station({ station }: { station: StationType }) {
  return (
    <div
      className={`col-start-[var(--col-start)] col-end-[var(--col-end)] p-1`}
      style={
        {
          '--col-start': station.getColStart(),
          '--col-end': station.getColEnd(),
        } as StyleProps
      }>
      <div
        className={`w-full h-full bg-[var(--bg-color)] border-[var(--border-color)] border border-solid rounded-md flex items-center justify-start p-2`}
        style={
          {
            '--bg-color': station.getFillColor(),
            '--border-color': station.getBorderColor(),
          } as StyleProps
        }>
        <div className="text-xs truncate">{station.arbeitsbereich.name}</div>
      </div>
    </div>
  );
}
